import {combineReducers} from 'redux'
import { reducer as formReducer } from 'redux-form'
import update from 'immutability-helper';


let searchForm = (state = {}, action) => {

    return state;
};
let searchResults = (state = {}, action) => {
    switch (action.type){
        case "REQUEST_SEARCH":
            return update(state, {
                searchValues: {
                    $set: action.searchValues
                }
            });
        case "RECEIVED_SEARCH_RESULTS":
            return update(state, {
                $unset: ['primarySearchError'],
                results: {
                    $set: action.results
                },
                hasSearchPerformed: {$set: true}
            });
        case "RECEIVED_SEARCH_ERROR":
            return update(state, {
                primarySearchError: action.primarySearchError
            });
        case "CLEAR_SEARCH":
            return update(state, {
               $unset: ['searchValues', 'results'],
            });
        default:
    }
    return state;
};
const i18n = (state = {
    currentLanguageKey: "sv"
}, action) => {
    switch (action.type) {
        case "SET_LANGUAGE":
            return Object.assign({}, state, {
                currentLanguageKey: action.languageCode
            });
        default:
            return state;
        // return Object.assign({}, state,  {
        //     currentLanguageKey: "en"
        // });
    }
};

let tamSearch = combineReducers({
    searchForm,
    searchResults,
    i18n,
    form: formReducer     // <---- Mounted at 'form'
});

export default tamSearch;


// WEBPACK FOOTER //
// ./src/reducers/index.js